module.exports = __webpack_public_path__ + "img/userhead.254ad2ed.png";